import { createSlice } from "@reduxjs/toolkit";
import { getPushLogs, getManualPush } from "./thunk";

export interface IState {
  pushLogs: any;
  isPushLogLoading: boolean;
  isPushLogSuccess: boolean;

  manualPush: any;
  isManualPushLoading: boolean;
  isManualPushSuccess: boolean;

  error: any;
}

export const initialState: IState = {
  pushLogs: null,
  isPushLogLoading: false,
  isPushLogSuccess: false,

  manualPush: null,
  isManualPushLoading: false,
  isManualPushSuccess: false,

  error: {},
};

const PushNotificationSlice = createSlice({
  name: "Notification",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    //get Push Logs
    builder.addCase(getPushLogs.pending, (state: IState, action: any) => {
      state.isPushLogLoading = true;
    });
    builder.addCase(getPushLogs.fulfilled, (state: IState, action: any) => {
      state.pushLogs = action.payload.data;
      state.isPushLogSuccess = true;
      state.isPushLogLoading = false;
    });
    builder.addCase(getPushLogs.rejected, (state: IState, action: any) => {
      state.error = action.payload.error || null;
      state.isPushLogSuccess = false;
      state.isPushLogLoading = false;
    });

    //get Manual Push
    builder.addCase(getManualPush.pending, (state: IState, action: any) => {
      state.isManualPushLoading = true;
    });
    builder.addCase(getManualPush.fulfilled, (state: IState, action: any) => {
      state.manualPush = action.payload.data;
      state.isManualPushSuccess = true;
      state.isManualPushLoading = false;
    });
    builder.addCase(getManualPush.rejected, (state: IState, action: any) => {
      state.error = action.payload.error || null;
      state.isManualPushSuccess = false;
      state.isManualPushLoading = false;
    });
  },
});

export default PushNotificationSlice.reducer;
